module.exports = __webpack_public_path__ + "static/media/muscular.a6f5d1e4.ogg";